import React from 'react';
import { CircleLogo, logo } from './assests';

const Footer = () => {
  return (
    <footer>
      <div className="row" style={{marginTop: 100, marginBottom: 100}}>
        {/* Content for the first row */}
        <div style={{width: 600, display: "flex", alignItems: "center"}}>
          <img src={CircleLogo} style={{ height: 100, width: 120 , marginLeft: 50}} />
          <p style={{fontSize: 25, fontWeight: "500"}}>ACE Engineerings & <br/>Chemicals Pvt Ltd</p>
        </div>
        <div style={{width: 450}}>
          <h2>COMPANY</h2>
          <h4>Product</h4>
          <h4>Technologies</h4>
          <h4>About US</h4>
          <h4>Contact US</h4>
          <p></p>
        </div>
        <div style={{width: 500, textAlign: "left"}}>
          <h2>CONTACT</h2>
          <h4>Phone no:</h4>
          {/* <img/> */}
          <p>9770501439</p>
          <h4>Address :</h4>
          {/* <img/> */}
          <p>No. 659/1, Rau-Rangwasa Road, Kishkindha Dham <br/>Industrial  Area Rau Dist. Indore, Madhya Pradesh, <br/> India - Pin 453331</p>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;
